import React from "react";
import "./reviews.css";

export default function Reviews({ yelpUrl = "https://reviewthis.biz/mickeys" }) {
  return (
    <section className="reviews">
      <div className="reviews-hero">
        <p className="reviews-title">Award Winning Flavor</p>
        <p className="reviews-sub">
          Loved by locals and recognized nationwide. We've earned major accolades from leading publications and racked up over <strong>500 five-star reviews</strong> from the Tampa community. Our commitment to quality has put us on the map as one of the best in the nation. See what all the buzz is about.
        </p>
      </div>

      <div className="reviews-grid">
        <ReviewCard
          title="America's Best Cheap Eats"
          awardedBy="USA Today"
          desc="Mickey's Subs in Tampa, Florida, was named the No. 1 place for cheap eats in America."
        />

        <ReviewCard
          title="Florida's Best Sub Sandwich Shop"
          awardedBy="Love Food"
          desc="Mickey’s doesn’t just serve the best subs in Florida. According to just about everyone who’s ever taken a bite of one of the shop’s torpedo-style sandwiches, they’re among the best anywhere."
        />

        <ReviewCard
          title="Best Deli & Sandwich Shop Finalist"
          awardedBy="Tampa Magazine"
          desc="Mickey's Subs earned the runner-up spot in Tampa Magazine's 2026 Best Restaurants awards, once again proving why locals keep coming back for its incredible sandwiches."
        />

      </div>


      <div className="reviews-cta">
        <p className="reviews-cta-text">
          Had a great experience you want to share?
        </p>
        <a
          className="reviews-btn"
          href={yelpUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Review Now
        </a>
      </div>
    </section>
  );
}

function ReviewCard({ title, awardedBy, desc }) {
  return (
    <article className="review-card">
      <div className="review-header">
        <div className="star-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" className="star-svg">
            <path d="M12 2l2.9 6.26L22 9.27l-5 4.9L18.2 22 12 18.77 5.8 22 7 14.17l-5-4.9 7.1-1.01L12 2z" />
          </svg>
        </div>
        <div className="review-title-group">
          <p className="review-title">{title}</p>
          <p className="review-awarded-by">Awarded by {awardedBy}</p>
        </div>
      </div>
      <div className="review-divider"></div>
      <div className="review-desc-wrapper">
        <span className="review-quote">“</span>
        <p className="review-desc">{desc}</p>
      </div>
    </article>
  );
}
